import React from 'react';
import {
  BrowserRouter as Router,
  Navigate,
  Route,
  Routes,
} from 'react-router-dom';
import './App.css';
import Header from './components/Layout/Header';
import Footer from './components/Layout/Footer';
import LectureUploadPage from './pages/LectureUploadPage';
import LectureStatusPage from './pages/LectureStatusPage';
import LectureFaqPage from './pages/LectureFaqPage';
import LecturePricingPage from './pages/LecturePricingPage';
import { AuthProvider } from './context/AuthContext';
import { LanguageProvider } from './i18n/LanguageContext';
import LectureHowToUsePage from './pages/LectureHowToUsePage';
import LecturePrivacy from './pages/LecturePrivacy';
import LectureTerms from './pages/LectureTerms';
import LectureVersionHistory from './pages/LectureVersionHistory';
import LectureSupportContact from './pages/LectureSupportContact';

const App = () => (
  <LanguageProvider>
    <AuthProvider>
      <Router>
        <div className="app-shell">
          <Header />
          <main className="app-main">
            <Routes>
              <Route path="/" element={<LectureUploadPage />} />
              <Route path="/lecture/upload" element={<Navigate to="/" replace />} />
              <Route path="/lecture/status" element={<LectureStatusPage />} />
              <Route path="/lecture/faq" element={<LectureFaqPage />} />
              <Route path="/lecture/faq/how-to-use" element={<LectureHowToUsePage />} />
              <Route path="/lecture/faq/privacy" element={<LecturePrivacy />} />
              <Route path="/lecture/faq/terms" element={<LectureTerms />} />
              <Route path="/lecture/faq/version" element={<LectureVersionHistory />} />
              <Route path="/lecture/pricing" element={<LecturePricingPage />} />
              <Route path="/lecture/status/:contextId" element={<LectureStatusPage />} />
              <Route path="/lecture/faq/support" element={<LectureSupportContact />} />
              <Route path="*" element={<Navigate to="/lecture/upload" replace />} />
            </Routes>
          </main>
          <Footer />
        </div>
      </Router>
    </AuthProvider>
  </LanguageProvider>
);

export default App;
